// Paise-integer money helpers per RULES Article 7.2.
// Never use floats. Display via Intl with en-IN grouping.

export type Paise = number;

export function rupeesToPaise(rupees: number): Paise {
  if (!Number.isFinite(rupees)) throw new Error("rupeesToPaise: non-finite input");
  return Math.round(rupees * 100);
}

export function paiseToRupees(paise: Paise): number {
  return Math.round(paise) / 100;
}

const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

const inrFormatterWithPaise = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export interface FormatCurrencyOptions {
  includePaise?: boolean;
}

export function formatCurrency(paise: Paise, options: FormatCurrencyOptions = {}): string {
  const rupees = paiseToRupees(paise);
  const formatter = options.includePaise ? inrFormatterWithPaise : inrFormatter;
  return formatter.format(rupees);
}

export function addPaise(...values: Paise[]): Paise {
  return values.reduce((acc, v) => acc + Math.round(v), 0);
}

export function multiplyPaise(paise: Paise, multiplier: number): Paise {
  return Math.round(paise * multiplier);
}

// Subscribe & Save 15% — single source for the discount math.
export const SUBSCRIBE_DISCOUNT = 0.15;

export function applySubscribeDiscount(paise: Paise): Paise {
  return multiplyPaise(paise, 1 - SUBSCRIBE_DISCOUNT);
}
